import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function InvoicingProvider({ children }) {
  useInjectSaga({ key: 'invoicingProvider', saga });
  useInjectReducer({ key: 'invoicingProvider', reducer });

  return React.Children.only(children);
}

InvoicingProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as useInvoicing } from './useInvoicing';
export { default as withInvoicing } from './withInvoicing';
export default compose(withConnect, memo)(InvoicingProvider);
